var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.125 60.375H25.875V36.225C25.875 35.7675 26.0567 35.3287 26.3802 35.0052C26.7037 34.6817 27.1425 34.5 27.6 34.5H41.4C41.8575 34.5 42.2963 34.6817 42.6198 35.0052C42.9433 35.3287 43.125 35.7675 43.125 36.225V60.375V60.375Z",
    strokeWidth: 4.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.65 60.375H43.125V52.0375C43.125 51.58 43.3067 51.1412 43.6302 50.8177C43.9537 50.4942 44.3925 50.3125 44.85 50.3125H58.65C59.1075 50.3125 59.5463 50.4942 59.8698 50.8177C60.1933 51.1412 60.375 51.58 60.375 52.0375V58.65C60.375 59.1075 60.1933 59.5463 59.8698 59.8698C59.5463 60.1933 59.1075 60.375 58.65 60.375V60.375Z",
    strokeWidth: 4.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 60.375V46.2875C25.875 45.83 25.6933 45.3912 25.3698 45.0677C25.0463 44.7442 24.6075 44.5625 24.15 44.5625H10.35C9.8925 44.5625 9.45374 44.7442 9.13024 45.0677C8.80674 45.3912 8.625 45.83 8.625 46.2875V58.65C8.625 59.1075 8.80674 59.5463 9.13024 59.8698C9.45374 60.1933 9.8925 60.375 10.35 60.375H25.875V60.375Z",
    strokeWidth: 4.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0675 14.6999L33.6809 9.1598C33.7514 9.00142 33.8664 8.86688 34.0118 8.77247C34.1572 8.67806 34.3269 8.62781 34.5003 8.62781C34.6736 8.62781 34.8433 8.67806 34.9887 8.77247C35.1341 8.86688 35.2491 9.00142 35.3196 9.1598L37.9359 14.6999L43.7779 15.594C44.5283 15.709 44.8273 16.675 44.2839 17.227L40.0576 21.5395L41.0553 27.6288C41.1818 28.4108 40.3998 29.0088 39.727 28.6379L34.5003 25.7629L29.2735 28.6379C28.6036 29.0059 27.8188 28.4108 27.9453 27.6288L28.9429 21.5395L24.7166 17.227C24.1704 16.675 24.4723 15.709 25.2198 15.594L31.0675 14.7028V14.6999Z",
    strokeWidth: 4.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResults);
export default __webpack_public_path__ + "static/media/Results.66f23d69.svg";
export { ForwardRef as ReactComponent };